// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createAccountStyles } from "@conklin/Overrides/Widgets/CreateAccount/CreateAccount";
import { hideElement, xScreen } from "@conklin/XDL/Utilities";
import { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";

createAccountStyles.userGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.textGridItem = {
    width: 12,
};

createAccountStyles.customerRadioGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
        padding-bottom: 0;
    `
};

createAccountStyles.submitErrorGridItem = {
    width: 12,
};

createAccountStyles.customerRadioGroup = {
    css: css`
        flex-direction: row;
        align-items: baseline;
        & > ${RadioStyle} {
            margin-right: 20px;
        }
    `,
};

createAccountStyles.userGridContainer = {
    gap: 20,
    css: css`
        &&& {
            max-width: 600px;
            margin: 0;
            ${xScreen("lte", "md")} {
                max-width: 100%;
            }
        }
    `,
};

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

createAccountStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};

createAccountStyles.requirementsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.submitButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

createAccountStyles.formFieldGridItem = { width: [12, 12, 6, 6, 6] };

createAccountStyles.errorMsg = {
    css: css`
        max-width: 100%;
        margin-bottom: 5px;
    `,
};
